import { CBadge } from "@coreui/react";

const Badge = (props) => {
  let addedClass = "";
  if (props.isOld === true) {
    switch (props.color) {
      case "success":
      case "danger":
        addedClass = "text-light";
        break;
      case "warning":
        addedClass = "text-dark";
        break;
      default:
        addedClass = "";
        break;
    }
  }
  addedClass = addedClass === undefined && "";
  return (
    <CBadge
      key={props.key}
      color={props.color}
      className={`mfs-auto ${addedClass} ${props.className}`}
    >
      {props.label}
    </CBadge>
  );
};

export default Badge;
